import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronsLeft, ChevronsRight, Waves } from 'lucide-react';

interface SidebarProps {
  isCollapsed: boolean;
  onToggle: () => void;
  navContent: React.ReactNode;
  profileContent: React.ReactNode;
  footerContent?: React.ReactNode;
  homePath?: string;
  navClassName?: string;
}

const Sidebar: React.FC<SidebarProps> = ({
  isCollapsed,
  onToggle,
  navContent,
  profileContent,
  footerContent,
  homePath = '/',
  navClassName = 'flex-1 p-2 overflow-y-auto custom-scrollbar',
}) => {
  return (
    <aside
      className={`flex flex-col fixed top-0 bottom-0 z-50 border-r border-border bg-surface transition-all duration-300 ${
        isCollapsed ? 'w-16' : 'w-72'
      }`}
    >
      <div className="border-b border-border p-4">
        {!isCollapsed ? (
          <div className="flex items-center justify-between">
            <Link
              to={homePath}
              className="flex items-center space-x-2 transition-opacity hover:opacity-80"
            >
              <Waves className="h-8 w-8 text-brand-logo-icon" aria-hidden />
              <span className="text-xl font-bold text-brand-logo-icon">GLYYD</span>
            </Link>
            <button
              type="button"
              onClick={onToggle}
              className="flex h-8 w-8 items-center justify-center rounded-full bg-accent text-accent-foreground transition-colors hover:bg-accent-hover"
              aria-label="Collapse sidebar"
            >
              <ChevronsLeft className="h-4 w-4" aria-hidden />
            </button>
          </div>
        ) : (
          <div className="relative mx-auto h-8 w-8 group">
            <Link
              to={homePath}
              className="flex h-8 w-8 items-center justify-center rounded-full text-brand-logo-icon transition-opacity duration-150 group-hover:opacity-0 group-focus-within:opacity-0"
              aria-label="Glyyd Home"
            >
              <Waves className="h-8 w-8" aria-hidden />
            </Link>
            <button
              type="button"
              onClick={onToggle}
              className="absolute inset-0 flex items-center justify-center rounded-full bg-accent text-accent-foreground opacity-0 transition-opacity duration-150 hover:bg-accent-hover focus:opacity-100 group-hover:opacity-100 group-focus-within:opacity-100"
              aria-label="Expand sidebar"
            >
              <ChevronsRight className="h-4 w-4" aria-hidden />
            </button>
          </div>
        )}
      </div>

      <nav className={navClassName}>{navContent}</nav>

      {footerContent}

      <div
        className={`border-t border-border ${isCollapsed ? 'px-2 pt-1.5 pb-2' : 'px-4 pt-2 pb-4'}`}
      >
        {profileContent}
      </div>
    </aside>
  );
};

export default Sidebar;
